import React from 'react';
import MainLayout from '../components/MainLayout';
import { Link } from 'react-router-dom';
import whoweare from '../assets/images/img/who-we-are.jpg';
import Accordion from 'react-bootstrap/Accordion';


export default function FlightInventoryManagement() {
  return (
    <>
    <MainLayout>

    <div className='breadcrumb_area'>
    <div className='photo'>
    <img src={whoweare} alt=''/>
      <div className='wrapper'> 
          <div className='container'>
          <div className='row'>
          <div className='col-12'>
          <h1 className='breadcrumb_title'>Flight Inventory Management System</h1>
          <ul className="breadcrumb_list">
          <li className="breadcrumb_item"><Link to='/'>Home</Link></li>
          <li className="breadcrumb_item">Flight Inventory Management System</li>                 
          </ul>
          </div>
          </div>
          </div>  
      </div>
    </div>
    </div>

    <div className='inner_page_content digital_marketing travel_tourism_b2b'> 
      <div className='container'>

          <div className='row'>
        
          <div className='col-12'>
              <h2>Travel Flight Inventory Module Features </h2>
              <p>Our Travel Flight Inventory Module is designed to streamline the management, booking, and distribution of flight inventory for travel agencies, tour operators, and corporate travel planners. The module provides efficient tools to manage flight inventory, enhance customer experience, and maximize revenue.</p>
        
        <h4>Key Features of Our Travel Flight Inventory Module:</h4>
        
          </div>

        <div className='col-12'>
        <Accordion>

<Accordion.Item eventKey="0">
  <Accordion.Header>Real-Time Flight Availability & Pricing</Accordion.Header>
  <Accordion.Body>
    <p>Access up-to-the-minute flight availability, seat allocation, and dynamic pricing from multiple airlines, ensuring your customers always have access to the latest options. Real-time updates minimize the chances of booking errors and improve the customer experience.</p>
  </Accordion.Body>
</Accordion.Item>

<Accordion.Item eventKey="1">
  <Accordion.Header>Multi-Airline Integration</Accordion.Header>
  <Accordion.Body>
    <p>Seamlessly integrates with multiple airlines, providing a centralized platform for booking flights from different carriers. This flexibility helps agencies offer a variety of options and competitive pricing to their clients.</p>
  </Accordion.Body>
</Accordion.Item>


<Accordion.Item eventKey="2">
  <Accordion.Header>Dynamic Pricing & Fare Rules</Accordion.Header>
  <Accordion.Body>
    <p>Automatically adjusts pricing based on demand, seasonality, and fare rules. The module ensures that you get real-time updates for special offers, discounts, and changes in fare rules, helping you provide competitive pricing and manage margins effectively.</p>
  </Accordion.Body>
</Accordion.Item>


<Accordion.Item eventKey="3">
  <Accordion.Header>Customizable Search Filters</Accordion.Header>
  <Accordion.Body>
    <p>Allows users to search and filter flights based on parameters like price, departure times, arrival times, flight duration, and airline preference. This makes it easier to tailor the flight search experience to meet specific customer needs.</p>
  </Accordion.Body>
</Accordion.Item>


<Accordion.Item eventKey="4">
  <Accordion.Header>Booking & Reservation Management</Accordion.Header>
  <Accordion.Body>
    <p>Streamline the booking process with a simple, user-friendly interface. The module allows easy reservation creation, modification, and cancellations, providing full control over the flight booking lifecycle from start to finish.</p>
  </Accordion.Body>
</Accordion.Item>


<Accordion.Item eventKey="5">
  <Accordion.Header>Seat Allocation & Management</Accordion.Header>
  <Accordion.Body>
    <p>Real-time access to seat availability ensures that agents can allocate the correct seats during the booking process. This feature helps manage overbookings and allows for easy management of special seating requests (e.g., extra legroom, business class).</p>
  </Accordion.Body>
</Accordion.Item>


<Accordion.Item eventKey="6">
  <Accordion.Header>Ticketing & E-Ticket Generation</Accordion.Header>
  <Accordion.Body>
    <p>Automatically generates electronic tickets (e-tickets) for all confirmed bookings, reducing paperwork and manual processing. The system ensures that the correct ticket details are sent to the customer, providing a seamless experience from booking to departure.</p>
  </Accordion.Body>
</Accordion.Item>


<Accordion.Item eventKey="7">
  <Accordion.Header>Comprehensive Reporting & Analytics</Accordion.Header>
  <Accordion.Body>
    <p>The module provides powerful analytics and reporting tools, allowing agencies to track booking trends, seat availability, sales performance, and more.</p>
  </Accordion.Body>
</Accordion.Item>

<Accordion.Item eventKey="8">
  <Accordion.Header>Multi-Currency & Multi-Language Support</Accordion.Header>
  <Accordion.Body>
    <p>This feature supports international businesses by allowing users to book flights in multiple currencies and languages, expanding your global reach and improving the user experience for customers from different regions.</p>
  </Accordion.Body>
</Accordion.Item>

<Accordion.Item eventKey="9">
  <Accordion.Header>Flexible Commission Management</Accordion.Header>
  <Accordion.Body>
    <p>The system allows you to set and manage commissions for different agents, channels, or partners. It tracks commissions automatically, ensuring accurate payouts and helping you manage relationships with affiliates or sub-agents efficiently.</p>
  </Accordion.Body>
</Accordion.Item>





</Accordion>


        </div>


        <div className='col-12 mt-4'>

        <h4> Benefits:</h4>

        <Accordion>

<Accordion.Item eventKey="0">
  <Accordion.Header>Improved Customer Experience</Accordion.Header>
  <Accordion.Body>
    <p>With access to real-time inventory and dynamic pricing, your customers can enjoy a personalized and seamless booking experience.</p>
  </Accordion.Body>
</Accordion.Item>

<Accordion.Item eventKey="1">
  <Accordion.Header>Enhanced Revenue Opportunities</Accordion.Header>
  <Accordion.Body>
    <p>The module helps travel agencies access more flight options, apply competitive pricing, and manage inventory efficiently to maximize sales and profitability.</p>
  </Accordion.Body>
</Accordion.Item>


<Accordion.Item eventKey="2">
  <Accordion.Header>Better Control</Accordion.Header>
  <Accordion.Body>
    <p>You have complete control over flight bookings, seat allocation, and pricing, with detailed reports to help you optimize your offerings.</p>
  </Accordion.Body>
</Accordion.Item>


<Accordion.Item eventKey="3">
  <Accordion.Header>Global Reach</Accordion.Header>
  <Accordion.Body>
    <p>Multi-currency and multi-language support enable agencies to cater to a broader international customer base.</p>
  </Accordion.Body>
</Accordion.Item>




      </Accordion>




          </div>

  
          </div>

      </div>
    </div>

    </MainLayout>
    </>
  )
}
